import { Injectable } from '@angular/core';
import {CanActivate} from '@angular/router';
import {Router} from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate{

  constructor(public router: Router) {
  }

  canActivate(): boolean {
    const user = JSON.parse(localStorage.getItem('user'));
    if (user == undefined || user == null){
      //console.log('No hay sesion activa, proxcede a iniciar');
      this.router.navigate(['/admin-login']);
      return false;
    }else{
        return true;
    }
  }

}
